module.exports = __webpack_public_path__ + "static/img/r-4-4-icon.b3c104d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-4/r-4-4-icon.png
// module id = +zGl
// module chunks = 0